import { TrackingSampleModalV1 } from './TrackingSampleModal.v1';
import { TrackingSampleModalV2 } from './TrackingSampleModal.v2';
import { useDynamicConfig } from '@statsig/react-bindings';

interface TrackingSampleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLearnMore?: () => void;
}

export const TrackingSampleModal = ({
  isOpen,
  onClose,
  onLearnMore,
}: TrackingSampleModalProps) => {
  const enableNewTracker = useDynamicConfig('public_config').get(
    'enable_new_tracker',
    false,
  );
  return enableNewTracker ? (
    <TrackingSampleModalV2
      isOpen={isOpen}
      onClose={onClose}
      onLearnMore={onLearnMore ?? (() => {})}
    />
  ) : (
    <TrackingSampleModalV1 isOpen={isOpen} onClose={onClose} />
  );
};
